import { AttributeGroup, Category, Country, CapsuleBrand, Retailer, Supplier, CapsuleUnitMeasure, Industry } from '@emi/shared/models';

export class CapsuleDto {
    constructor(
        public emiItemId: number,
        public name: string,
        public englishName: string,
        public description: string,
        public ingredients: string,
        public country: Country,
        public category: Category,
        public emiImageUrl: string,
        public industry: Industry,
        public brand: CapsuleBrand,
        public retailers: Retailer[],
        public supplier: Supplier,
        public attributeGroups: AttributeGroup[],
        public measures: CapsuleUnitMeasure[],
    ) { }
}